"use client";

import React from "react";

import { Card } from "@/components/flowbite/card";

import { SectionTitle } from "./section-title";
import { SkeletonBox } from "./skeleton-box";

export const SchoolPanelSkeleton: React.FC = () => {
  return (
    <div className="space-y-6 px-3 py-4">
      {/* Basic Info — 4 rows h-4, padding like student */}
      <div>
        <SectionTitle title="Basic Info" />
        <div className="mt-2 flex flex-col gap-3 space-y-0 py-1">
          {[1, 2, 3, 4, 5, 6, 7, 8, 9].map((i) => (
            <div
              key={i}
              className="flex h-4 gap-2"
            >
              <SkeletonBox className="h-4 w-24 shrink-0" />
              <SkeletonBox className="h-4 flex-1" />
            </div>
          ))}
        </div>
      </div>

      {/* Attendance Zone Boundary — one card, same layout as real */}
      <div className="flex flex-col gap-2">
        <SectionTitle title="Attendance Zone Boundary" />
        <div className="flex w-full flex-col gap-2">
          <Card className="flex items-center gap-2 p-2.5 pl-3">
            <SkeletonBox className="h-10 w-10 shrink-0 rounded" />
            <div className="flex flex-1 flex-col gap-1">
              <SkeletonBox className="h-4 w-32" />
              <SkeletonBox className="h-3 w-24" />
            </div>
          </Card>
        </div>
      </div>

      {/* Files — one row skeleton so layout doesn't jump */}
      <div>
        <SectionTitle title="Files" />
        <div className="mt-2 flex w-full flex-col gap-2">
          <Card className="flex items-center gap-2 p-2.5 pl-3">
            <SkeletonBox className="h-4 flex-1" />
            <SkeletonBox className="h-6 w-6 shrink-0 rounded" />
          </Card>
        </div>
      </div>
    </div>
  );
};
